import TulpTool from './Tools/TulpTool';

export default function App() {
  return <TulpTool />;
}
